import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FlexBox, Text } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import moment from 'moment-timezone';
import { useMemo } from 'react';
import { useAnalyticsState } from 'analytics/components/panels/utils/useAnalyticsState/useAnalyticsState';
import { TagChips } from 'components/tags/tagChips';
import { formatMillisecondsToDuration } from 'utils/formatting/dateTime';
import { formatAbbreviateNumber, formatLocalizedNumber, } from 'utils/formatting/number';
import { PercentageBar } from '../../../../percentageBar/percentageBar';
import { TableInstrumentConversationId } from './components/conversationId/tableInstrumentConversationId';
import { TableInstrumentLongText } from './components/longText/tableInstrumentLongText';
export const TableInstrumentDataValue = ({ panel, cell, format, }) => {
    const { settings: { timezone }, } = useAnalyticsState();
    const value = typeof (cell === null || cell === void 0 ? void 0 : cell.value) === 'string' ? cell.value.trim() : cell === null || cell === void 0 ? void 0 : cell.value;
    const hasNoValue = useMemo(() => {
        const isNull = value === null;
        const isEmptyString = typeof value === 'string' && value === '';
        const isEmptyList = Array.isArray(value) && !value.length;
        return !cell || isNull || isEmptyString || isEmptyList;
    }, [cell, value]);
    const output = useMemo(() => {
        if (hasNoValue)
            return (_jsx(Text.Paragraph, Object.assign({ variant: "2", color: colors.neutral['500'] }, { children: "n.a." })));
        switch (format) {
            case 'boolean':
                return value ? 'Y' : 'N';
            case 'date':
                return moment.tz(value, timezone).format('L, LT');
            case 'count':
                return formatAbbreviateNumber(value);
            case 'number':
                return formatLocalizedNumber(value);
            case 'percentage':
                return `${formatLocalizedNumber(value)}%`;
            case 'duration':
                return formatMillisecondsToDuration(value);
            case 'csid':
                return (_jsx(TableInstrumentConversationId, { csid: value, panel: panel }));
            case 'rating':
                return `${value}`;
            case 'presence':
                return _jsx(PercentageBar, { value: value, showFullBar: true });
            case 'tags':
                return (_jsx(FlexBox, Object.assign({ gap: "100" }, { children: _jsx(TagChips, { tags: value, limit: 1 }) })));
            case 'text':
                return _jsx(TableInstrumentLongText, { text: value });
            case 'string':
            default:
                return `${value}`;
        }
    }, [format, hasNoValue, panel, timezone, value]);
    return _jsx(_Fragment, { children: output });
};
